import {getArtistToken} from "../../../auth/token.saga";
import {extractDataFromResponse} from "../../../saga-utils/httpInterceptorWrapper";
import {getKundenByKundIdList} from "../../../../api/kundenApi";
import {
    LOAD_DOUBLETTEN_MERGE_KUNDEN,
    loadDoublettenMergeKundenFailureAction,
    loadDoublettenMergeKundenSuccessAction
} from "../../listActions";
import {emitNotificationAction} from "../../../notification/notificationAction";
import {createErrorNotification} from "../../../../models/notification";
import i18next from "i18next";
import {call, put, takeLatest} from "redux-saga/effects";
import {i18_LIST} from "../../../../i18nReferences";

function* processLoadMergeKundenData({payload}) {
    try {
        const token = yield getArtistToken()
        const kundIdList = payload.kundIdPair.split('-')
        if (token) {
            const kunden = extractDataFromResponse(yield call(getKundenByKundIdList, {token, kundIdList}))
            yield put(loadDoublettenMergeKundenSuccessAction(kunden))
        }
    } catch (err) {
        yield put(emitNotificationAction(createErrorNotification(i18next.t('LIST_DOUBLETTEN.LOAD_DOUBLETTEN_DATA_FAILED_INFO', {ns: i18_LIST}), 'loadMergeKundenData')))
        yield put(loadDoublettenMergeKundenFailureAction())
        console.log(err)
    }
}

export function* watchLoadMergeKundenData() {
    yield takeLatest(LOAD_DOUBLETTEN_MERGE_KUNDEN, processLoadMergeKundenData)
}